// extracted by mini-css-extract-plugin
export default {"wrap":"Cp-z","logoContainer":"Dp-z","brandImg":"Ep-z","logoImg":"Fp-z","logoButton":"Gp-z"};